import { Button, Col, Divider, Row, Typography } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import BackgroundImage from "@/resources/homepage_background.jpg";

import styles from "./styles.less";

export default () => (
  <div className={styles.main}>
    <img src={BackgroundImage} className={styles.backgroundImage} />
    <Row gutter={24} justify={"center"}>
      <Col>
        <Typography.Title className={styles.title}>Backtest Tool</Typography.Title>
        <Divider />
        <Typography.Paragraph className={styles.paragraph}>
          <ul>
            <li>
              <p> No coding experience required. </p>
            </li>
            <li>
              <p> Easy to use. </p>
            </li>
            <li>
              <p> Insighful results. </p>
            </li>
          </ul>
        </Typography.Paragraph>
        <Divider />
        <Row justify={"center"}>
          <Link to={"/backtest"}>
            <Button type={"default"} className={styles.button} ghost size={"large"}>
              Let's Begin
              <svg>
                <rect width={"100%"} height={"100%"} rx={"5"} />
              </svg>
            </Button>
          </Link>
        </Row>
      </Col>
    </Row>
  </div>
);
